import React, { useState } from 'react';
import { GiftIcon, CheckIcon, ChevronDownIcon } from 'lucide-react';
import { BuyButton } from './BuyButton';
interface Bonus {
  emoji: string;
  title: string;
  tagline: string;
  items: string[];
}
const bonuses: Bonus[] = [{
  emoji: '🗂️',
  title: 'BONO 1 — Kit de Plantillas Clínicas Listas para Usar',
  tagline: 'Lo que usarías en tu primer día de trabajo',
  items: ['Historia clínica editable en Word/PDF', 'Checklist de anamnesis por especie (perro, gato, conejo, roedor)', 'Ficha de seguimiento de paciente hospitalizado', 'Formato de consentimiento informado para el propietario', 'Hoja de cálculo de fluidos y dosis de emergencia']
}, {
  emoji: '💊',
  title: 'BONO 2 — Vademécum Veterinario Resumido: Las 50 Drogas Esenciales',
  tagline: 'El PDF que vas a tener siempre abierto en el celular',
  items: ['50 fármacos con: dosis, vía, frecuencia, especie, observaciones', 'Ordenado por sistema (digestivo, cardiovascular, nervioso, antibióticos, etc.)', 'Señalizados los fármacos ⚠️ peligrosos en gatos', 'Incluye dosis de emergencia destacadas en rojo', 'Formato tabla, optimizado para imprimir en A4 o ver en celular']
}, {
  emoji: '🧠',
  title: 'BONO 3 — Banco de 50 Preguntas de Examen con Respuestas Explicadas',
  tagline: 'Estudiá como si ya supieras lo que te van a tomar',
  items: ['50 preguntas de opción múltiple estilo universitario', 'Cubre: farmacología, clínica, emergencias y laboratorio', 'Cada respuesta tiene explicación clínica detallada', 'Organizadas por dificultad: básica / intermedia / avanzada']
}, {
  emoji: '🗺️',
  title: 'BONO 4 — Mapa Mental de Diagnósticos Diferenciales por Signo Clínico',
  tagline: 'El mapa que te dice qué pensar cuando el animal no te habla',
  items: ['15 signos clínicos clave (vómito, diarrea, convulsiones, disnea, poliuria, colapso, ictericia, etc.)', 'Para cada signo: árbol de diagnósticos diferenciales ordenados por probabilidad', 'Diferenciación por especie (perro vs. gato) donde corresponde', 'Formato visual tipo mapa mental, optimizado para imprimir en A3 o ver en tablet', 'Ideal para llevar a la rotación clínica como guía de consulta rápida']
}, {
  emoji: '📅',
  title: 'BONO 5 — Planificador de Estudio de 90 Días para Veterinaria',
  tagline: 'Convierte tu caos de apuntes en un plan con fecha de vencimiento',
  items: ['Cronograma semanal de 90 días organizado por materias y bloques temáticos', 'Sistema de revisión espaciada para retener lo que estudiás a largo plazo', 'Tracker diario de hábitos: horas de estudio, descanso, repaso y práctica clínica', 'Checklist de objetivos semanales con casillas tachables', 'Diseñado para estudiantes de cualquier año de la carrera']
}, {
  emoji: '⚠️',
  title: 'BONO 6 — Guía de Intoxicaciones Frecuentes en Perros y Gatos',
  tagline: 'Lo que tenés que saber antes de que el dueño llegue en pánico',
  items: ['20 tóxicos más frecuentes en consulta: ibuprofeno, paracetamol, chocolate, uvas, xilitol, organofosforados, rodenticidas, plantas tóxicas y más', 'Para cada tóxico: mecanismo de daño, signos clínicos, ventana de acción y protocolo de manejo', 'Tabla de dosis tóxicas por kg para los más comunes', 'Qué hacer y qué NO hacer en los primeros 30 minutos', 'Formato tarjeta de bolsillo, imprimible y con código de colores por urgencia']
}];
export function Bonuses() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);
  return <section className="w-full py-14 px-4 bg-gradient-to-b from-white to-green-50/50" data-id="element-12">
      <div className="max-w-3xl mx-auto" data-id="element-13">
        <div className="text-center mb-8" data-id="element-14">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-yellow-100 text-yellow-800 font-bold text-sm mb-3" data-id="element-15">
            <GiftIcon className="w-4 h-4" data-id="element-16" /> GRATIS POR HOY
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-slate-900" data-id="element-17">
            + 6 BONOS de regalo si pedís hoy
          </h2>
          <p className="mt-2 text-slate-600 max-w-2xl mx-auto text-sm sm:text-base" data-id="element-18">
            Incluidos{' '}
            <span className="font-bold text-green-700" data-id="element-19">100% gratis</span> solo
            para los pedidos de hoy.
          </p>
        </div>

        <div className="space-y-2.5" data-id="element-20">
          {bonuses.map((b, i) => {
          const isOpen = openIdx === i;
          return <div key={i} className={`rounded-xl border-2 overflow-hidden transition-all ${isOpen ? 'border-green-400 bg-white shadow-md' : 'border-green-100 bg-white hover:border-green-300'}`} data-id="element-21">
                <button onClick={() => setOpenIdx(isOpen ? null : i)} className="w-full flex items-center justify-between gap-3 px-4 py-3 text-left" data-id="element-22">
                  <div className="flex items-start gap-3 flex-1 min-w-0" data-id="element-23">
                    <span className="text-2xl flex-shrink-0" data-id="element-24">{b.emoji}</span>
                    <div className="min-w-0" data-id="element-25">
                      <h3 className="font-extrabold text-sm sm:text-base text-slate-900 leading-tight" data-id="element-26">
                        {b.title}
                      </h3>
                      <p className="text-xs sm:text-sm text-green-700 italic mt-0.5 truncate" data-id="element-27">
                        "{b.tagline}"
                      </p>
                    </div>
                  </div>
                  <ChevronDownIcon className={`w-5 h-5 flex-shrink-0 text-green-600 transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-28" />
                </button>
                <div className={`grid transition-all duration-300 ${isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`} data-id="element-29">
                  <div className="overflow-hidden" data-id="element-30">
                    <ul className="px-4 pb-4 space-y-1.5 border-t border-green-100 pt-3" data-id="element-31">
                      {b.items.map((it, j) => <li key={j} className="flex items-start gap-2 text-sm text-slate-700" data-id="element-32">
                          <CheckIcon className="w-4 h-4 text-green-600 flex-shrink-0 mt-0.5" data-id="element-33" />
                          <span className="leading-snug" data-id="element-34">{it}</span>
                        </li>)}
                    </ul>
                  </div>
                </div>
              </div>;
        })}
        </div>

        <div className="text-center mt-8" data-id="element-35">
          <BuyButton label="QUIERO TODO + LOS 6 BONOS" pulse data-id="element-36" />
          <p className="text-xs text-slate-500 mt-3" data-id="element-37">
            ⚠️ Los bonos son gratis solo por el día de hoy.
          </p>
        </div>
      </div>
    </section>;
}